import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import styles, { rowTheme } from './styles'

const Table = ({ theme, className, children }) => <table className={cx(styles.table, className, rowTheme(theme))}>{children}</table>

Table.propTypes = {
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'light', 'dark', 'tertiary', 'info']),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
}

Table.defaultProps = {
  theme: 'primary',
}

export default Table
